module.exports = __webpack_public_path__ + "static/media/bg.75cef13b.png";